import { render, staticRenderFns } from "./paperEdit.vue?vue&type=template&id=0e7c5b1f&scoped=true&"
import script from "./paperEdit.js?vue&type=script&lang=js&"
export * from "./paperEdit.js?vue&type=script&lang=js&"
import style0 from "./paperEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./paperEdit.sass?vue&type=style&index=1&id=0e7c5b1f&lang=sass&rel=stylesheet%2Fsass&scoped=true&"
import style2 from "./paperExercise.sass?vue&type=style&index=2&lang=sass&rel=stylesheet%2Fsass&"
import style3 from "./paperEdit.vue?vue&type=style&index=3&lang=sass&rel=stylesheet%2Fsass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c5b1f",
  null
  
)

export default component.exports